import { IComment } from "immigram-ui-cmon/src/components/Comments/Comments";
import { createContext } from "react";

export interface IApplicationContext {
  comments: IComment[];
  unresolvedCommentsCount?: number;
  meta: {
    commentTitle?: string;
  };
}

export const ApplicationContext = createContext<IApplicationContext>({
  comments: [],
  meta: {},
});

export default ApplicationContext;
